import * as React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router";
import { IUser } from "../shared/getCurrentUser";

type Props = {
  userInfo: IUser | undefined;
};

export function UserInfoAndLicencesSection({ userInfo }: Props) {
  const { t } = useTranslation();

  if (!userInfo) {
    return <p>{t("home.error")}</p>;
  }

  if (userInfo.Bought) {
    const isSubscriber = Boolean(userInfo.StripeSubscriptionId);
    return (
      <div>
        <ul>
          <li>
            <p>
              {t(
                isSubscriber
                  ? "userLicenses.hasSubscription"
                  : "userLicenses.hasLicense",
              )}
            </p>
          </li>
          {userInfo.StripeCustomerId && (
            <li>
              <a href="/buy/billingportal">{t("userLicenses.manageBilling")}</a>
            </li>
          )}
        </ul>
      </div>
    );
  }

  return (
    <div>
      <p>{t("userLicenses.noLicense")}</p>
      <Link to="/buy">
        <p>{t("userLicenses.buyHere")}</p>
      </Link>
    </div>
  );
}
